export default "__VITE_ASSET__0c303e61__"